<template>

  <div class="text-sm text-justify leading-5 bg-white rounded p-3" @scroll="onScroll">
    <div class="text-2xl font-bold pb-2">PRIVACY POLICY</div>
    <div class="py-2 font-bold underline text-lg">I. Introduction</div>
    <div class="py-2">
     This Privacy Policy is adopted in compliance <span class="font-bold">Republic Act No. 10173</span> , otherwise
     known as the “<span class="font-bold">Data Privacy Act of 2012</span>” (DPA), its Implementing Rules and Regulations
     (IRR), and other relevant rules and policies, including issuances of the National Privacy
     Commission (NPC).
    </div>
    <div class="py-2">
     This policy outlines the data protection and security measures adopted by the Philippine Army Finance Center Producers Integrated Cooperative (PAFCPIC) to safeguard and protect data privacy rights and shall serve as a guide in the exercise of rights under the DPA.
    </div>
    <div class="py-2 font-bold underline text-lg">II. Policy Statement</div>
    <div class="py-2">
      We, at Philippine Army Finance Center Producers Integrated Cooperative (PAFCPIC), are committed to provide you with quality and innovative services while implementing safeguards to protect your privacy and keep your personal information safe and secure in compliance with the DPA.
      All officers and employees of PAFCPIC are enjoined to comply with and to share the responsibility to secure and protect personal information, including sensitive personal information, collected and processed by the Cooperative in pursuit of legitimate purposes.
    </div>
    <div class="py-2 font-bold underline text-lg">III. Definition of Terms</div>
    <div class="pt-2">
      A. Data Subject refers to an individual whose personal, sensitive personal, or privileged information is processed.
    </div>
    <div>
      B. Personal information refers to any information whether recorded in a material form or not, from which the identity of an individual is apparent or can be reasonably and directly ascertained by the entity holding the information, or when put together with other information would directly and certainly identify an individual. 
    </div>
     <div>
      C. Sensitive personal information refers to personal information: 
    </div>
    <div class="py-2 pl-5">
      1.	About an individual’s race, ethnic origin, marital status, age, color, and religious, philosophical or political affiliations;
    </div>
    <div class="pl-5">
      2.	About an individual’s health, education, genetic or sexual life of a person, or to any proceeding for any offense committed or alleged to have been committed by such person, the disposal of such proceedings, or the sentence of any court in such proceedings;
    </div>
    <div class="pl-5">
      3.	Issued by government agencies peculiar to an individual which includes, but not limited to, social security numbers, previous or cm-rent health records, licenses or its denials, suspension or revocation, and tax returns; and
    </div>
    <div class="pl-5">
      4.	Specifically established by an executive order or an act of Congress to be kept classified.
    </div>
    <div class="pt-2">
      D. Processing refers to any operation or any set of operations performed upon personal information including, but not limited to, the collection, recording, organization, storage, updating or modification, retrieval, consultation, use, consolidation, blocking, erasure or destruction of data. 
    </div>
     <div>
      E. Personal information controller refers to a person or organization who controls the collection, holding, processing or use of personal information, including a person or organization who instructs another person or organization to collect, hold, process, use, transfer or disclose personal information on his or her behalf. 
    </div>
     <div>
      F. Data Protection Officer refers to an individual designated by the head of agency or organization to be accountable for its compliance with the DPA, its IRR, and other issuances of the NPC. 
    </div>
    <div class="py-4 font-bold underline text-lg">IV. Processing of Personal Information</div>
    <div class="py-2 font-bold">
      1.	Collection of Personal Information
    </div>
    <div class="py-2">
      In the course of our transactions with data subjects, PAFCPIC may collect personal information including, but not limited to:
    </div>
    <div>
      1.	Name, sex, civil status, residential address, date and place of birth, age, citizenship
    </div>
    <!-- <div></div> -->
    <div>
      2.	Parents’ name, religion, nationality, date and place of birth, occupation, and other information in Birth Certificate
    </div>
    <div>
      3.	Military serial number, rank, Tax Identification Number (TIN), GSIS or SSS number
    </div>
    <div>
      4.	Employment status, occupation, service term, employer, office address
    </div>
    <div>
      5.	Monthly and annual income, financial situation
    </div>
    <div>
      6.	Contact numbers, e-mail address, and emergency contact information
    </div>
    <div>
      7.	Spouse’s name, date and place of birth, residence, citizenship, religion, parents,
    </div>
    <div>
      8.	Date and place of marriage, solemnizing officer, and other information in Marriage Certificate
    </div>
    <div>
      9.	Name of legal beneficiaries and their personal information
    </div>
    <div>
      10.	Medical condition and history
    </div>
    <div>
      11.	Specimen signatures
    </div>
    <div>
      12.	Scholastic and other academic records
    </div>
    <div>
      13.	Date and place of death, cause of death, and other information in Death Certificate
    </div>
    <div>
      14.	Images via CCTV and other similar recordings taken within office premises or during activities conducted out of office
    </div>
    <div class="py-2">
     A data subject’s personal information may be collected through the following ways:
    </div>

    <div>
      1.	Application for membership by filling out the required forms and submitting additional requirements
    </div>
    <div>
      2.	Application for loans or other financial and integrated services by filling out the required forms and submitting additional requirements
    </div>
    <div>
      3.	Interaction with our employees, either written or verbal, through face-to-face transactions, phone, e-mail, or social media inquiries
    </div>
    <div>
      4.	Filling out of the required forms for inquiries, requests, comments, or complaints
    </div>
    <div>
      5.	Participation in surveys, focus group discussions, marketing promotions, and other similar initiatives
    </div>
    <div>
      6.	Submission of requirements for job application
    </div>
    <div>
      7.	Submission of requirements for scholarship or other requests for assistance
    </div>
    <div>
      8.	Recording of images and videos through CCTV within office premises
    </div>
    <div>
      9.	Application for voluntary termination or deceased termination filed by legal beneficiaries by filling out the required forms and submitting additional requirements
    </div>
    <div>
      10.	Other similar means
    </div>

    <div class="py-2 font-bold">2.	Use and Disclosure of Personal Information</div>
    <div class="pt-2">
      PAFCPIC uses and discloses collected personal information for the following purposes:
    </div>
    <div>1.	To manage membership of individuals in the cooperative</div>
    <div>2.	To provide quality financial and integrated products and services</div>
    <div>3.	To provide assistance and feedback to members</div>
    <div>4.	To communicate relevant services, advisories, promotions, including responses to queries, requests, and complaints</div>
    <div>5.	To allow members to participate in promotional activities, special events, and community initiatives</div>
    <div>6.	To undertake marketing and promotional campaigns</div>
    <div>7.	To implement prevention, detection, and corrective measures in relation to fraud and other relevant risks</div>
    <div>8.	To evaluate and process applications for employment</div>
    <div>9.	To comply with the requirements of Republic Act 9510 (“Credit Information System Act”)</div>
    <div>10. To comply with the requirements of other relevant existing laws and legal proceedings such as court orders</div>
    <div>11. To comply with the legal obligation to prevent imminent harm to public security, safety, or order</div>
    <div>12. To utilize relevant data for research, analytical, and promotional purposes</div>
    <div>13. To undertake other similar legitimate purposes</div>

    <div class="py-2 font-bold">3.	Sharing of Personal Information to Third Parties</div>
    <div class="py-2">
      In the course of operations and providing services to members, PAFCPIC may engage the services of third parties. In instances when certain personal information is required to be disclosed to fulfill legitimate business concerns and as may be necessary to provide services, we shall exercise utmost diligence in processing your personal information. PAFCPIC will never share, sell, or otherwise disclose your personal information with third parties, except as otherwise indicated above, or unless otherwise permitted under the Data Privacy Act or other applicable laws and regulations.
    </div>
    <div class="py-2 font-bold">4.	Accessing and Updating your Personal Information</div>
    <div class="py-2">
      Members may access and update personal information previously collected from them by proceeding to any of our PAFCPIC Satellite Offices (PSOs) and submitting a written request to authorized employees. This information will be available for members’ access during business hours and after a reasonable period of time for us to prepare the same.
    </div>
    <div class="py-2 font-bold">5.	Personal Information Retention and Disposal</div>
    <div class="py-2">
     The personal information of data subjects shall be retained by PAFCPIC only for as long as it is necessary to fulfill the purpose/s for which it was obtained and in accordance with the prescribed retention period depending on the nature of the personal information collected and subject to the specific retention policy of the department or section storing such information.
    </div>
    <div class="py-2">
      Thereafter, the personal information shall be disposed of or de-identified in a secure manner sufficient to make the information non-personally identifiable in order to prevent further processing, unauthorized access, or unlawful disclosure to any other party.
    </div>
    <div class="py-4 font-bold underline text-lg">V. Data Protection</div>
    <div class="py-2">
      PAFCPIC implements reasonable and appropriate organizational, physical, and technical security measures for the protection of personal information which we collected.
    </div>
     <div class="py-2">
      The security measures aim to maintain the availability, integrity, and confidentiality of personal information and are intended for the protection of personal information against any accidental or unlawful destruction, alteration, and disclosure, as well as against any other unlawful processing
    </div>
     <div class="py-2">
      In compliance with the DPA, PAFCPIC has appointed a Data Protection Officer (DPO) to manage and safeguard the processing of your personal information. A Data Privacy Section under the direct supervision of the DPO was also established for the same purpose. PAFCPIC commits itself to ensuring that your personal information is secured and protected under the standards provided for by law and in line with the best practices of the industry.
    </div>
    <div class="py-4 font-bold underline text-lg">VI. Confidentiality</div>
    <div class="py-2">
      PAFCPIC employees process and hold personal information under strict confidentiality. They are required to sign non-disclosure agreements and are trained on the company’s privacy and security policies to ensure confidentiality and security of your personal information.
    </div>
    <div class="py-4 font-bold underline text-lg">VII. Rights of the Data Subjects</div>
    <div class="py-2">
      Data subjects are entitled to the following rights:
    </div>
    <div>A. Be informed of when and how personal information shall be, is being or has been processed;</div>
    <div>B. Be furnished with the information indicated below before the entry of personal information into the processing system of the personal information controller, or at the next practical opportunity:</div>
    <div class="pl-5">(1) Description of the personal information to be entered into the system;</div>
    <div class="pl-5">(2) Purposes for which it is being or are to be processed;</div>
    <div class="pl-5">(3) Scope and method of the personal information processing;</div>
    <div class="pl-5">(4) The recipients or classes of recipients to whom it is or may be disclosed;</div>
    <div class="pl-5">(5) Methods utilized for automated access, if the same is allowed by the data subject, and the extent to which such access is authorized;</div>
    <div class="pl-5">(6) The identity and contact details of the personal information controller or its representative;</div>
    <div class="pl-5">(7) The period for which the information will be stored; and</div>
    <div class="pl-5">(8) The existence of their rights, i.e., to access, correction, as well as the right to lodge a complaint before the Commission.</div>
    <div class="py-2">
      Any information supplied or declaration made to the data subject on these matters shall not be amended without prior notification: Provided, That the notification under subsection (b) shall not apply should the personal information be needed pursuant to a subpoena or when the collection and processing are for reasonably apparent purposes, including when it is necessary for the performance of or in relation to a contract or service or when necessary or desirable in the context of an employer-employee relationship, or when the information is being collected and processed as a result of legal obligation;
    </div>
    <div class="py-2">
      C.Reasonable access to, upon demand, the following:
     </div>
      <div class="pl-5">(1) Contents of personal information that were processed;</div>
      <div class="pl-5">(2) Sources from which personal information were obtained;</div>
      <div class="pl-5">(3) Names and addresses of recipients of the personal information and sensitive personal information;</div>
      <div class="pl-5">(4) Manner by which such data were processed;</div>
      <div class="pl-5">(5) Reasons for the disclosure of the personal information to recipients;</div>
      <div class="pl-5">(6) Information on automated processes where the data will or likely to be made as the sole basis for any decision significantly affecting or will affect the data subject;</div>
      <div class="pl-5">(7) Date when personal information was last accessed and modified; and</div>
      <div class="pl-5">(8) The designation, or name or identity and address of the personal information controller (PIC).</div>
      <div>D. Dispute the inaccuracy or error in the personal information and have the personal information controller correct it immediately and accordingly, unless the request is vexatious or otherwise unreasonable. If the personal information has been corrected, the PIC shall ensure the accessibility of both the new and the retracted information and the simultaneous receipt of the new and the retracted information by recipients thereof: Provided, That the third parties who have previously received such processed personal information shall be informed of its inaccuracy and its rectification upon request of the data subject;</div>
      <div>E. Suspend, withdraw or order the blocking, removal or destruction of personal information from the PIC’s filing system upon discovery and substantial proof that the personal information are incomplete, outdated, false, unlawfully obtained, used for unauthorized purposes or are no longer necessary for the purposes for which they were collected; and</div>
      <div>F. Be indemnified for any damages sustained due to such inaccurate, incomplete, outdated, false, unlawfully obtained or unauthorized use of personal information.</div>
      <div>G. Where personal information is processed by electronic means and in a structured and commonly used format, data subjects have the right to obtain from the PIC a copy of data undergoing processing in an electronic or structured format, which is commonly used and allows for further use.</div>
      <div class="py-4 font-bold underline text-lg">VIII. Amendments and Updates to Privacy Policy</div>
      <div>PAFCPIC reserves the right to regularly update and amend its Privacy Policy, as needed, to comply with legal and regulatory requirements, to reflect changes in the Cooperative’s processes and procedures, to align with industry practice, to adopt new technologies and methodologies, or for other legitimate purposes. Any significant updates or amendments to the Privacy Policy shall be duly communicated and disseminated to all concerned parties.</div>
      <div class="py-4 font-bold underline text-lg">IX. Contact Information</div>
    <div class="py-2 font-bold">CONTACT INFORMATION</div>
    <div class="py-2">If you have further questions or concerns, you may contact our Data Protection Officer through the following details:</div>
    <div class="py-2">Contact Number: (02) 8844-9010 loc. 310</div>
    <div class="py-2">Email Address: dpo.pafcpic@gmail.com</div>
    <div class="py-3"><a href="https://media.pafcpic.net/resource/NPC_SEAL_OF_REGISTRATION.pdf" target="_blank" class="underline"> NATIONAL PRIVACY COMMISSION SEAL </a></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
 mounted(){
    this.$emit("scrolltop");
},
methods:{
  onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
    // console.log(scrollTop, clientHeight, scrollHeight);
      if (scrollTop + clientHeight >= (scrollHeight*.95)) {
        // console.log(scrollHeight);
          this.$emit("done");
      }
    }
}
});

</script>